import { ReportType } from './common';

export function isIssueListReportType(
  reportType: ReportType
): reportType is ReportType.issueList {
  return reportType === ReportType.issueList;
}

export function isSingleIssueReportType(
  reportType: ReportType
): reportType is ReportType.singleIssue {
  return reportType === ReportType.singleIssue;
}

export function isInspectionReportType(
  reportType: ReportType
): reportType is ReportType.inspection {
  return reportType === ReportType.inspection;
}

export function isIssueReportType(
  reportType: ReportType
): reportType is ReportType.issueList | ReportType.singleIssue {
  return isIssueListReportType(reportType) || isSingleIssueReportType(reportType);
}
